// extracted by mini-css-extract-plugin
export default {"featured":"FeaturedInSection_featured__bHoWo","grid":"FeaturedInSection_grid__5nSfK","video":"FeaturedInSection_video__spccF","iframe":"FeaturedInSection_iframe__TZiXK"};